import { render, staticRenderFns } from "./MetricInfo.vue?vue&type=template&id=ff35ef4c&scoped=true&"
import script from "./MetricInfo.vue?vue&type=script&lang=js&"
export * from "./MetricInfo.vue?vue&type=script&lang=js&"
import style0 from "./MetricInfo.vue?vue&type=style&index=0&id=ff35ef4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff35ef4c",
  null
  
)

export default component.exports